<template>
	<svg
		width="31"
		height="17"
		viewBox="0 0 31 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.38101 2.29346L10.5647 7.80958C7.98153 9.41838 6.23948 12.2529 6.15578 15.5004H0C0 9.91538 2.95256 5.02398 7.38139 2.29373L7.38101 2.29346Z"
			fill="#2A8176"
		/>
		<path
			d="M22.7478 1.7963L19.5591 7.32709C18.3289 6.73155 16.956 6.39702 15.4996 6.39702C14.0383 6.39702 12.6554 6.73155 11.4252 7.33207L8.23645 1.80582C10.4019 0.654549 12.872 0 15.4994 0C18.117 0 20.5875 0.649567 22.7474 1.7963H22.7478Z"
			fill="#2A8176"
		/>
		<path
			d="M30.9999 15.5003H24.8442C24.7605 12.2478 23.0137 9.40315 20.4205 7.79944L23.6043 2.28809C28.0424 5.01423 31.0001 9.91029 31.0001 15.5003L30.9999 15.5003Z"
			fill="#2A8176"
		/>
		<path
			d="M14.7779 13.8925C14.1151 14.2964 13.909 15.1588 14.3166 15.8214C14.7275 16.4885 15.5935 16.6978 16.2563 16.2934L16.6916 15.8821L21.7893 11.0098L15.1663 13.7318L14.7779 13.8925Z"
			fill="#2A8176"
		/>
	</svg>
</template>

